<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
    <ng-container formArrayName="pricedetail">
      <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroup]="detail">

        <div fxLayout.xs="column"  fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 1</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title1' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title1" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 2</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title2' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title2" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 3</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title3' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title3" />
                </mat-form-field>
            </div>
        </div>


        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Starter Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-s-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Profession Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-p-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Advanced Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-a-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_price_annualy" />
                </mat-form-field>
            </div>
        </div>

            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Starter Price lifetime</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-s-price-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_price_life" />
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Profession Price lifetime</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-p-price-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_price_life" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Advanced Price lifetime</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-a-price-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_price_life" />
                    </mat-form-field>
                </div>
            </div>

            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Starter Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-s-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_charge_year" />
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Profession Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-p-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_charge_year" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Advanced Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-a-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_charge_year" />
                    </mat-form-field>
                </div>
            </div>            

            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Starter Charge detail life</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-s-charge-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_charge_life" />
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Profession Charge detail life</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-p-charge-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_charge_life" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Advanced Charge detail life</mat-label>
                        <input [attr.guide]="'price-table-plan2-inp-a-charge-life' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_charge_life" />
                    </mat-form-field>
                </div>

            <!-- <div fxFlex="10">
                <button [attr.guide]="'price-table-plan2-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deletePricingDetail(i)">Delete</button>
            </div> -->
        </div>                        

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button name</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-s-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_button" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button link</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-p-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_button" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Background color</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-a-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_button" />
                </mat-form-field>
            </div>
         </div>                        

         <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Starter Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-s-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_subtitle" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Profession Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-p-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_subtitle" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Advanced Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-a-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_subtitle" />
                </mat-form-field>
            </div>
        </div>  

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Toptitle fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-toptitle-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="Toptitle_font" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>title1 fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title1-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title1_font" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>title2 fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title2-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title2_font" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>subtitle fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-subtitle-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="subtitle_font" />
                </mat-form-field>
            </div>
        </div>  

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Toptitle Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-toptitle-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="Toptitle_mobfont" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>title1 Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title1-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title1_mobfont" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>title2 Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-title2-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title2_mobfont" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>subtitle Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-subtitle-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="subtitle_mobfont" />
                </mat-form-field>
            </div>
        </div>  

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>column backGround</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-column-color' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="column_color" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-button-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="button_font" />
                </mat-form-field>
            </div>            
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-button-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="button_mobfont" />
                </mat-form-field>
            </div>            

        </div>


        <ng-container formArrayName="list_detail">
          <div *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item" style="border: 1px solid lightgray;padding: 15px;margin: 5px;">
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <!-- <mat-form-field fxFlex>
                    <mat-label>Sub Title</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-sub-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title" />
                </mat-form-field> -->

                <mat-form-field fxFlex>
                    <mat-label>Starter</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-starters' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="starters" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Profession</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-professions' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="professions" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Advanced</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-advanceds' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="advanceds" />
                </mat-form-field>
            </div>
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label>Option1</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-option1' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option1" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Option2</mat-label>
                    <input [attr.guide]="'price-table-plan2-inp-option2' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option2" />
                </mat-form-field>

                <div fxFlex>
                    <button [attr.guide]="'price-table-plan2-btn-2' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete</button>
                </div>
            </div>

          </div><br/>
          <button [attr.guide]="'price-table-plan2-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addListDetail(i)">Add List</button>
        </ng-container><br/>
      </div><br/>
      <!-- <button [attr.guide]="'price-table-plan2-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addPricingDetails()">Add Pricing Detail</button> -->
    </ng-container><br/>
    <button [attr.guide]="'price-table-plan2-btn-5' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" type="submit" style="margin-top: 10px;margin-bottom: 10px;" >{{btntext}}</button>
  </form>
  